export const FindPerfectInvitationsSectionData = {
  mainText: {
    title: 'Find the perfect invitation in print or online.',
    body:
      'Explore hundreds of beautiful wedding invitation designs, from textured watercolor to striking modern minimalism. Whether online or with matching prints, every invite comes with easy RSVP and a powerful website for your guests.',
  },
  exploreDesigns: 'Browse Invitations',
};
